export default "__VITE_ASSET__DmeoO1cS__"